import { cva } from 'class-variance-authority';

export const SearchIcon = cva(['text-brand-pure']);

export const WrapperInput = cva(['flex', 'flex-col', 'gap-6']);

export const pickerWrapperInput = cva(['flex', 'w-full', 'gap-2']);
